import FEATURE_NAME from "../enums/FeatureName";
import { IUserFeature } from "../types/AdvanceFeature";

export function isLandingPagesEnabled(features: IUserFeature[]): boolean {
  const landingPageFeature = features.find(
    (item) => item.feature?.name === FEATURE_NAME.LANDING_PAGE
  );
  return landingPageFeature?.feature?.enabled ?? false;
}
